// extracted by mini-css-extract-plugin
export default {"AuthPage":"AuthPage_AuthPage__F-ZcN","form_holder":"AuthPage_form_holder__FtLU1","background":"AuthPage_background__xs2al"};